import React from 'react';
import { Compass, Zap, Target, Rocket, GraduationCap, HeartHandshake, CloudSun, Wrench, Shield, FolderArchive, Gauge, UsersRound, DoorOpen } from 'lucide-react';
import { SUITE_META } from '@/data/landing2Data';

const ICONS = { Compass, Zap, Target, Rocket, GraduationCap, HeartHandshake, CloudSun, Wrench, Shield, FolderArchive, Gauge, UsersRound, DoorOpen };

export function SuiteGlyph({ sid, className = 'h-5 w-5' }) {
  const meta = SUITE_META[sid];
  const Icon = ICONS[meta.icon];
  return <Icon className={className} style={{ color: meta.color }} />;
}

export function SuiteChip({ sid, size = 'sm' }) {
  const meta = SUITE_META[sid];
  const pad = size === 'sm' ? 'px-3 py-1.5 text-xs' : 'px-4 py-2 text-sm';
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold border whitespace-nowrap ${pad}`}
      style={{ color: meta.color, borderColor: `${meta.color}55`, background: `${meta.color}0F` }}
    >
      <SuiteGlyph sid={sid} className="h-3.5 w-3.5" />
      {meta.name}
    </span>
  );
}
